import { Provider, Type } from '@angular/core';
import { environment } from '../environments/environment';
import { ENV_NAME } from './env-name.injection-token';
import { ENV_PROD_BUILD } from './env-production.injection-token';
import { ENV_RELEASE_VERSION } from './env-release-version.injection-token';
import { UserEnvironmentService } from './user-environment.service';

export function provideEnvironment(userEnvironmentService?: Type<UserEnvironmentService>): Provider[] {
  const providers: Provider[] = [
    {
      provide: ENV_PROD_BUILD,
      useValue: environment.production_build,
    },
    {
      provide: ENV_NAME,
      useValue: environment.name || 'local',
    },
    {
      provide: ENV_RELEASE_VERSION,
      useValue: environment.release_version || '',
    },
  ];

  if (userEnvironmentService) {
    providers.push({
      provide: UserEnvironmentService,
      useClass: userEnvironmentService,
    });
  }

  return providers;
}
